import React, {useState} from "react";
import styled from "styled-components";
import Button from "@components/common/Button";
/** @type {string} */
import IcAlertInfo from "../../assets/icons/ic_alert_info.svg";
import {observer} from "mobx-react-lite";
import grapesjs from "grapesjs";
import {editorOptions, findCustomCmp, findOneDepthParent} from "../../app/editor";
import "grapesjs/dist/css/grapes.min.css";
import GjsEditor, {AssetsProvider, Canvas, StylesProvider, TraitsProvider} from '@grapesjs/react';
import {usePluginStore} from "../../app/store/pluginStore";
import {getAppEditorStore, useAppEditorStore} from "../../app/store/appEditorStore";
/** @type {string} */
import Grid from "@components/editor/Grid";
import GridItem from "@components/editor/GridItem";
import {pad} from "@components/editor/theme";
import TraitManager from "@components/editor/TraitManager";
import StyleManager from "@components/editor/StyleManager";
import cx from "../../app/editor/utils/makeCls"
import {getCommonModalDevicePanelProperties} from "../../app/editor/Panel";
import {toast} from "react-toastify";
import {ModalBody} from "./Modal";
import {useStore} from "../../app/store";
import {createId, rgbToHex} from "../../app/editor/utils";
import AssetManager from "../editor/AssetManager";
import BuiltInRTE from "../editor/RichTextEditor/BuiltInRTE";

const CommonBoardEditorModal = observer(({boardData, handleCloseModal, modalDepth}) => {
    const clsPanel = 'overflow-y-auto overflow-x-hidden max-w-full';
    const {isCssPanelActive, setSelectedDesignerTab} = useAppEditorStore();
    const smCls = cx(isCssPanelActive && 'hidden');
    const pluginStore = usePluginStore();
    const gjsPlugins = pluginStore.getPluginsToLoad();
    const {appEditorStore, confirmStore, modalStore} = useStore();
    const [textInfoViewHover, setTextInfoViewHover] = useState(false);

    const closeCommonEditBtn = () => {
        handleCloseModal(modalDepth);
    }
    const commonBoardAllChange = async () => {
        if (boardData) {
            modalStore.openModal({
                ...modalStore.MODAL_PAYLOAD.SAVE_ITEM('COMMON', appEditorStore.commonEditor.DomComponents.getComponents().models[0]),
                closeFunc: (callback) => {
                    callback();
                    appEditorStore.editor.Commands.run('reload-scripts');
                }
            }, null);
        } else {
            confirmStore.openConfirm({
                confirmText: "반영",
                text: "이 보드와 연결된\n전체 상세 페이지에 적용됩니다.\n일괄 반영하시겠습니까?",
                confirmFunc: async () => {
                    try {
                        await appEditorStore.updateCommonBoard();
                        toast("공통보드 수정 및 일괄 반영이 완료되었습니다.");
                    } catch (e) {
                        console.log(`공통보드 수정 및 일괄 반영에 실패하였습니다.\n${e.message}`);
                    } finally {
                        confirmStore.clear();
                    }
                },
            });
        }


    }
    const textMouseHover = () => {
        setTextInfoViewHover(true);
    }
    const textMouseOut = () => {
        setTextInfoViewHover(false);
    }
    const onCommonEditor = async (commonEditor) => {
        commonEditor.on('load', function () {
            appEditorStore.setCommonEditor(commonEditor);
            commonEditor.Keymaps.keymaster.unbind('delete');
            commonEditor.Keymaps.keymaster.unbind('backspace');
            commonEditor.UndoManager.stop();
            commonEditor.Panels.addPanel(getCommonModalDevicePanelProperties());
            if (boardData) {
                appEditorStore.commonBoardEditorModalSetData(boardData);
                commonEditor.Commands.run('reload-scripts');
            } else {
                if (appEditorStore.commonBoardEditorModal.state) {
                    appEditorStore.commonBoardEditorModalSetData();
                    commonEditor.Commands.run('reload-scripts');
                }
            }
        });


        commonEditor.on('component:toggled', function (model) {
            if (!model) return;
            if (model.attributes && model.attributes.tagName && model.attributes.tagName === "body") {
                commonEditor.select();
            }
        });
        commonEditor.on('component:selected', function (model) {
            if (model.attributes && model.attributes.tagName && model.attributes.tagName === "body") {
                model.set('toolbar', []);
                return;
            }
            if (model.getClasses().includes('connected_board_wrapper')) {
                model.set('toolbar', []);
                commonEditor.select(null);
                return toast('최상위 영역은 수정할 수 없습니다.')
            }
            commonEditor.trigger("styleManager:update", model);
            if (model.getClasses().length === 0) {
                model.addClass(`detail_span_${createId(5)}`);
                model.addClass(`XeRqh${createId(6)}`)
            }
            let toolBarList = [];
            appEditorStore.relocateHighlighter();
            const customModel = findCustomCmp(model)
            toolBarList = [{
                "label": `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L4 10H9V22H15V10H20L12 2Z" fill="currentColor"/></svg>`,
                "command": "tlb-parent"
            }, {
                "label": "<svg viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z\" /></svg>",
                "command": "tlb-clone"
            }, {
                "label": "<svg viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z\" /></svg>",
                "command": "tlb-delete"
            }]
            if (customModel && customModel.getClasses().includes('accordion_table')) {
                /** 2025.01.07: 테이블 수정을 위한 커스텀 툴바 적용*/
                toolBarList = model.toolbar;
            } else if (model.attributes.tagName === 'img') {
                /** 20250108: 컬러콤비의 경우 이미지를 링크로 변환할 경우 스와이퍼 전체에 문제가 생겨서 해당 부분 제외하는 코드 추가*/
                if (!model.getClasses().includes('cc__obj-box-img')) { // && model.parent().attributes.tagName !== "a") {
                    if (model.toolbar.length === 1) {
                        toolBarList = toolBarList.concat(model.toolbar);
                    } else {
                        toolBarList = model.toolbar;
                    }
                }
            }
            model.set('toolbar', toolBarList);
        });
        commonEditor.Commands.add('tlb-parent', (editor) => {
            const selected = editor.getSelected();
            if (selected) {
                const parent = selected.parent();
                if (parent) {
                    editor.select(parent);
                }
            }
        });
        commonEditor.Commands.add('tlb-delete', ed => {
            const selected = ed.getSelected();
            const customModel = findCustomCmp(selected);
            if (customModel) {
                if (customModel && customModel.view.el.attributes['connected-comp-id'] && customModel.view.el.attributes['connected-comp-id'].value) {
                    const connectedComponent = commonEditor.DomComponents.getById(customModel.view.el.attributes['connected-comp-id'].value);
                    connectedComponent.destroy();
                }
                if (customModel && customModel.view.el.attributes['obj-img-id'] && customModel.view.el.attributes['obj-img-id'].value) {
                    const objImgIdList = customModel.view.el.attributes['obj-img-id'].value.split(',');
                    for (const objImgId of objImgIdList) {
                        const objImgComponent = commonEditor.DomComponents.getById(objImgId);
                        objImgComponent.destroy();
                    }
                }
                const parentCustomModel = customModel.parent();
                let isColorBtnOn = false;
                if (customModel.getClasses().includes('on') && customModel.getClasses('color_btn')) {
                    isColorBtnOn = true;
                }
                customModel.destroy();
                if (isColorBtnOn) {
                    const firstCustomModel = parentCustomModel.getChildAt(0);
                    if (firstCustomModel) {
                        firstCustomModel.parent().forEachChild((child) => child.removeClass('on'));
                        firstCustomModel.addClass('on');
                        if (firstCustomModel.view.el.attributes['connected-comp-id'] && firstCustomModel.view.el.attributes['connected-comp-id'].value) {
                            const connectedComponent = commonEditor.DomComponents.getById(firstCustomModel.view.el.attributes['connected-comp-id'].value);
                            connectedComponent.parent().forEachChild((child) => child.removeClass('on'));
                            connectedComponent.addClass('on');
                        }
                        if (firstCustomModel.view.el.attributes['obj-img-id'] && firstCustomModel.view.el.attributes['obj-img-id'].value) {
                            const objImgIdList = firstCustomModel.view.el.attributes['obj-img-id'].value.split(',');
                            for (const objImgId of objImgIdList) {
                                const objImgComponent = commonEditor.DomComponents.getById(objImgId);
                                objImgComponent.parent().forEachChild((child) => child.removeClass('on'));
                                objImgComponent.addClass('on');
                            }
                        }
                    }
                }
            } else {
                selected.destroy();
            }
            ed.select(null);
            ed.Commands.run('reload-scripts');
        });


        commonEditor.Commands.add('tlb-clone', ed => {
            const selected = ed.getSelected();
            const customModel = findCustomCmp(selected);
            if (customModel) {
                if (customModel.view.el.attributes['connected-comp-id']) {
                    const connectedTextComponent = commonEditor.DomComponents.getById(customModel.view.el.attributes['connected-comp-id'].value);
                    const cloneConnectedTextComponent = connectedTextComponent.parent().append(connectedTextComponent.toHTML(), {at: connectedTextComponent.index() + 1})[0];
                    connectedTextComponent.parent().forEachChild((child) => child.removeClass('on'));
                    connectedTextComponent.addClass('on');
                    appEditorStore.getComponentSelector(cloneConnectedTextComponent, true);
                }
                if (customModel.view.el.attributes['obj-img-id']) {
                    const objImgIds = customModel.view.el.attributes['obj-img-id'].value.split(",");
                    for (const objImgId of objImgIds) {
                        const connectedImgComponent = commonEditor.DomComponents.getById(objImgId);
                        const cloneConnectedImgComponent = connectedImgComponent.parent().append(connectedImgComponent.toHTML(), {at: connectedImgComponent.index() + 1})[0];
                        connectedImgComponent.parent().forEachChild((child) => child.removeClass('on'));
                        connectedImgComponent.addClass('on');
                        appEditorStore.getComponentSelector(cloneConnectedImgComponent, true);
                    }
                }
                const cloneCustomModel = customModel.parent().append(customModel.toHTML(), {at: customModel.index() + 1})[0];
                customModel.parent().forEachChild((child) => child.removeClass('on'));
                customModel.addClass('on');
                appEditorStore.getComponentSelector(cloneCustomModel, true);
            } else {
                const cloneModel = selected.parent().append(selected.toHTML(), {at: selected.index() + 1})[0];
                const selectorInfo = appEditorStore.getComponentSelector(cloneModel);
                selectorInfo.html = cloneModel.toHTML();
            }
            ed.select(null);
            ed.Commands.run('reload-scripts');
        });


        commonEditor.on('component:styleUpdate', function (model) {
            const higherComponent = findOneDepthParent(model);
            let targetCss = commonEditor.StyleManager.getSelected();
            if (!targetCss) {
                return;
            }
            /** @type {string[]} */
            const modelClasses = model.getClasses();
            let editedClassId, randomClassId;
            for (let i = 0; i < modelClasses.length; i++) {
                if (modelClasses[i].startsWith('DeRcN')) {
                    editedClassId = modelClasses[i];
                    randomClassId = modelClasses[i + 1];
                    break;
                }
            }
            if (!editedClassId) {
                editedClassId = `DeRcN${createId(4)}`;
                randomClassId = `XeRqh${createId(6)}`;
                model.addClass(editedClassId);
                model.addClass(randomClassId);
                const selectors = model.getSelectors();
                if (targetCss.attributes.selectorsAdd.length > 0) {
                    targetCss.attributes.selectorsAdd = `${targetCss.attributes.selectorsAdd}.${editedClassId}.${randomClassId}`;
                } else {
                    targetCss.set('selectors', selectors);
                }
                const previousCssRule = commonEditor.CssComposer.getRule(targetCss.attributes.previousCssRule);
                if (previousCssRule) {
                    const newStyleObject = {};
                    for (const styleKey in targetCss.attributes.style) {
                        if (!previousCssRule.attributes.style[styleKey] || previousCssRule.attributes.style[styleKey] !== targetCss.attributes.style[styleKey]) {
                            newStyleObject[styleKey] = targetCss.attributes.style[styleKey];
                        }
                    }
                    targetCss.setStyle(newStyleObject);
                }
            } else {
                if (Object.keys(targetCss.attributes.style).length === 0) {
                    model.removeClass(editedClassId);
                    model.removeClass(randomClassId);
                }
            }

            commonEditor.addStyle(targetCss);
            const higherComponentStyles = appEditorStore.getOneDepthComponentCssRules(higherComponent);
            const sortedStyles = higherComponentStyles.sort((a, b) => {
                const aMedia = a.get('mediaText') || '';
                const bMedia = b.get('mediaText') || '';
                return aMedia.length - bMedia.length;
            })
            higherComponentStyles.forEach(cssRule => cssRule.destroy());
            sortedStyles.forEach(cssRule => commonEditor.addStyle(cssRule))
            if ((model.getClasses().includes('swiper-slide') || model.getClasses().includes('color_btn')) && model.view.el.attributes['obj-img-id'].value && targetCss.attributes.style['background-color']) {
                model.view.el.setAttribute('data-color', targetCss.attributes.style['background-color'].startsWith('rgb') ? rgbToHex(targetCss.attributes.style['background-color']) : targetCss.attributes.style['background-color']);
                model.attributes.attributes['data-color'] = targetCss.attributes.style['background-color'].startsWith('rgb') ? rgbToHex(targetCss.attributes.style['background-color']) : targetCss.attributes.style['background-color']
                appEditorStore.commonEditor.Commands.run('reload-scripts');
                targetCss.destroy();
            }
        });


        commonEditor.on('rte:enable', (rte, component) => {
            if (rte && rte.el) {
                rte.el.addEventListener('paste', (event) => {
                    event.preventDefault();
                    const plainText = event.clipboardData.getData("text/plain");

                    const selection = commonEditor.Canvas.getWindow().getSelection();
                    if (!selection?.rangeCount) return;

                    const range = selection.getRangeAt(0);
                    range.deleteContents();
                    range.insertNode(document.createTextNode(plainText));
                });
            }
        })
        commonEditor.on('change:device', async function (model) {
            appEditorStore.commonEditor.Commands.run('reload-scripts');
        });
    }

    return (
        <ModalBody id={"CommonBoardEditorInnerModal"}>
            <EditCommonBoardEditorWrap className={"modal-container"}>
                <CommonBoardBtnArea>
                    <div className="common-modal-panel_devices"/>
                    <CommonStateApplyBtn>
                        <BoardToolTipWrap
                            onMouseEnter={textMouseHover}
                            onMouseLeave={textMouseOut}
                        >
                            <img src={IcAlertInfo} alt={"일괄반영 정보"}/>
                            {
                                textInfoViewHover &&
                                <span>일괄 반영 시 이 보드와 연결된 전체 상세페이지에 적용됩니다.</span>
                            }
                        </BoardToolTipWrap>
                        <Button
                            type={"fill"}
                            size={"m"}
                            text={"저장하기"}
                            onClickFunc={commonBoardAllChange}
                        />
                    </CommonStateApplyBtn>
                </CommonBoardBtnArea>
                <CommonBoarEditorArea>
                    <GjsEditor
                        grapesjs={grapesjs}
                        grapesjsCss={`${import.meta.env.VITE_CLOUDFRONT_URL}/grapes.min.css`}
                        options={editorOptions}
                        plugins={gjsPlugins}
                        onEditor={onCommonEditor}
                    >
                        <div className={"canvas-inner"}>
                            <Canvas className="app-canvas relative">
                            </Canvas>
                        </div>
                        <CommonBoarEditorStyleManger>
                            <EditLayerStyleInner>
                                <Grid col full>
                                    <GridItem className={cx(pad.xyS, clsPanel) + ' no-pad '} label="Properties">
                                        <TraitsProvider>
                                            {(props) => {
                                                let filteredTraits = props.traits.filter((trait) => trait.attributes.name === "href");
                                                const appEditorStore = getAppEditorStore();
                                                if (appEditorStore && appEditorStore.commonEditor && appEditorStore.commonEditor.DomComponents) {
                                                    const selectedComponent = appEditorStore.commonEditor.getSelected();
                                                    if (selectedComponent) {
                                                        if (selectedComponent.attributes.tagName === 'video') {
                                                            filteredTraits = props.traits.filter((trait) => trait.attributes.name === "src");
                                                        } else {
                                                            const parentComponent = selectedComponent.parent();
                                                            if (parentComponent.attributes.tagName === 'a') {
                                                                props.traits = parentComponent.getTraits();
                                                                filteredTraits = props.traits.filter((trait) => trait.attributes.name === "href")
                                                            }
                                                        }
                                                    }
                                                }
                                                props.traits = filteredTraits;
                                                return filteredTraits.length > 0 ? <TraitManager {...props}/> : null
                                            }}
                                        </TraitsProvider>
                                    </GridItem>
                                    <GridItem className={clsPanel + ' over_hid '} grow>
                                        <StylesProvider>
                                            {(props) => <>
                                                <StyleManager {...props}/>
                                            </>}
                                        </StylesProvider>
                                    </GridItem>
                                </Grid>
                                <AssetsProvider>
                                    {({assets, select, close, Container}) => (<Container>
                                        <AssetManager assets={assets} select={select} close={close}/>
                                    </Container>)}
                                </AssetsProvider>
                                <BuiltInRTE/>
                            </EditLayerStyleInner>
                        </CommonBoarEditorStyleManger>
                    </GjsEditor>
                </CommonBoarEditorArea>
                <div className={"modal-close"}>
                    <Button
                        size={"xl"}
                        text={"닫기"}
                        onClickFunc={closeCommonEditBtn}
                    />
                </div>
            </EditCommonBoardEditorWrap>
        </ModalBody>
    );
});
const CommonBoardEditorWrap = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
// const ModalBody = styled.div`

// `;
const CommonBoarEditorArea = styled.div`
    height: 550px;
    padding: 24px 0;
    background-color: #F5F5F5;
    position: relative;

    .canvas-inner {
        height: 100%;
    }
`;
const CommonBoarEditorStyleManger = styled.div`
    width: 280px;
    height: 100%;
    background: #3b3b3b;
    position: absolute;
    top: 0;
    right: 0;
`;
const EditLayerStyleInner = styled.div`
    overflow-y: scroll;
    max-height: 100%;

    .no-pad {
        padding: 0;
        overflow: hidden;

        .app-trait-manager {
            .text-center {
                padding: 20px 10px;
            }
        }
    }

    .over_hid {
        overflow: visible;
    }
`;
const CommonBoardBtnArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const CommonStateApplyBtn = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    margin-bottom: 16px;

    > button {
        margin-left: 12px;
    }
`;
const BoardToolTipWrap = styled.div`
    cursor: pointer;
    position: relative;

    > span {
        position: absolute;
        top: 24px;
        left: 50%;
        transform: translateX(-50%);
        width: 315px;
        color: #FFF;
        font-size: 11px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: -0.11px;
        background-color: #161616;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        padding: 3px 0;
        z-index: 99999;
    }
`;


const ModalHeader = styled.div`
    background: var(--Gray-1000_-262626, #262626);
    height: 48px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-left {
        display: flex;
        align-items: center;

        h1 {
            color: var(--White_-FFFFFF, #fff);
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; /* 150% */
            letter-spacing: -0.16px;
            margin-right: 15px;
        }

        .common-undo-manager-icon-wrap {
            position: relative;
        }
    }

    svg {
        cursor: pointer;
    }
`;

const EditCommonBoardEditorWrap = styled.article`
    margin: 0 auto;
    overflow: hidden;
    background-color: #fff;
    padding: 32px;


    .common-modal-panel_devices {
        position: relative;
        padding: 0;

        .gjs-pn-btn {
            padding: 8px;

            &.common-modal-devices-mobile-btn {
                margin-right: 0;
            }

            &.active {
                background-color: #C86733;
            }
        }
    }


    .modal-close {
        width: 100%;
        padding: 32px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;

        > button {
            width: 365px;
            background-color: #262626;
            color: #fff;
        }
    }

    .gjs-mdl-dialog {
        position: fixed;
        z-index: 99;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        width: 600px;
        height: 400px;
        animation: none;

        .gjs-mdl-content {
            height: calc(100% - 47px);
        }

        #gjs-mdl-c {
            height: 100%;
        }

        .gjs-am-custom-wrp {
            height: 100%;
        }

        .gjs-am-custom-wrp > div {
            height: 100%;
            flex-wrap: nowrap;
        }

        div[id^="headlessui-popover-panel"] {
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%);

            .text-white.bg-zinc-700.border.rounded.border-transparent.px-2.py-1 {
                display: none;
            }
        }
    }

    .table-insert-column-left,
    .table-insert-column-right,
    .table-insert-row-top,
    .table-insert-row-bottom,
    .table-delete-column,
    .table-delete-row {
        width: 28px;
        height: 28px;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center;
    }

    .table-insert-column-left {
        background-image: url('https://cdn.andar-publish.com/assets/images/icon/table_insert_column_left_w.png'); /* 커스텀 아이콘 경로 */
        background-size: 18px;
    }


    .table-insert-column-right {
        background-image: url('https://cdn.andar-publish.com/assets/images/icon/table_insert_column_right_w.png'); /* 커스텀 아이콘 경로 */
        background-size: 18px;
    }

    .table-insert-row-top {
        background-image: url('https://cdn.andar-publish.com/assets/images/icon/table_insert_row_top_w.png'); /* 커스텀 아이콘 경로 */
        background-size: 18px;
    }

    .table-insert-row-bottom {
        background-image: url('https://cdn.andar-publish.com/assets/images/icon/table_insert_row_bottom_w.png'); /* 커스텀 아이콘 경로 */
        background-size: 18px;
    }

    .table-delete-column {
        background-image: url('https://cdn.andar-publish.com/assets/images/icon/table_delete_column_w.png'); /* 커스텀 아이콘 경로 */
        background-size: 18px;
    }

    .table-delete-row {
        background-image: url('https://cdn.andar-publish.com/assets/images/icon/table_delete_row_w.png'); /* 커스텀 아이콘 경로 */
        background-size: 18px;
    }

    .convert_link {
        width: 26px;
        height: 26px;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('https://cdn.andar-publish.com/assets/images/icon/convert_link_w.png'); /* 커스텀 아이콘 경로 */
        background-size: 17px;
    }
`;


const TableDisplay = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const Dimmer = styled.div`
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
`;
export default CommonBoardEditorModal;
